import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';
import { IconContext } from 'react-icons/lib'
import IconLogo from '../../../images/IconLogo.png';
import {
    Nav,
    NavbarContainer,
    NavLinkLogo,
    NavLogo,
    MobileIcon,
    NavBtn,
    NavBtnLink
} from './NavbarElements';

const Navbar = ({ toggle }) => {

    const [scrollNav, setScrollNav] = useState(false)

    const changeNav = () => {
        if (window.scrollY >= 80) {
            setScrollNav(true)
        } else {
            setScrollNav(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav)
    }, [])

    const toggleHome = () => {
        scroll.scrollToTop();
    };

    return (
        <>
            <IconContext.Provider value={{ color: '#fff' }} >
                <Nav scrollNav={scrollNav} className="lightColor">
                    <NavbarContainer>
                        <NavLinkLogo className="lightColor" to="/" onClick={toggleHome}>
                            <NavLogo src={IconLogo} />
                        </NavLinkLogo>
                        <MobileIcon onClick={toggle}>
                            <FaBars />
                        </MobileIcon>
                        <NavBtn>
                            <NavBtnLink className="secondaryBackground darkColor" to="/">Menu</NavBtnLink>
                        </NavBtn>
                    </NavbarContainer>
                </Nav>
            </IconContext.Provider>
        </>
    );
};

export default Navbar
